import {InventoryLocationInteractionMode} from "./interaction";
import {
    drawInventoryLocationStyle,
    inventoryLocationThermalImagingTransectsFeatureStyle,
    inventoryLocationThermalImagingTransectsLineStyle
} from "../../../../map/styles/inventory-locations";
import {EpInventoryLocations} from "../../../../map/layers/inventory-locations";
import {Collection} from "ol";
import * as turf from "@turf/turf";
import {getLength} from "ol/sphere";
import * as $ from "jquery";
import {InventoryLocationInteractionMulti} from "./interaction-multi";
import {EpLayer} from "../../../../map/layers/layer";
import {
    createPolygonFeatureByLineAndWidth,
    featureToGeoJSONObject,
    generateLinesBasedOnPoints,
    generatePointsOnLine,
    geoJSONtoOLFeature
} from "../../../../map/utilities";
import proj4 from "proj4";
import {closeModal, openModal, roundToNearest} from "../../../../utilities";
import {nanoid} from "nanoid";
import {EpInventoryLocationTransects} from "../../../../map/layers/inventory-location-transects";
import {confirmModal} from "../../../../confirmModal";

const ZONE_LENGTH = 40;
const ZONE_DEFAULT_DEPTH = 80;
const ZONE_MAX_DEPTH = 600;

export class InventoryLocationInteractionThermalImagingTransects extends InventoryLocationInteractionMulti {
    /**
     * @type {EpLayer|null}
     */
    geometryFeaturesEpLayer = null;
    simplifiedFeaturesEpLayer = null;

    geometryFeatures = [];

    geometryCoordinatesCache = {};

    zoneDepth = null;
    areaType = null;

    /**
     * @param {InventoryLocationInteractionsHandler} handler
     */
    constructor(handler) {
        const layer = new EpInventoryLocations(handler.epMap.map);
        layer.farStyle = null;
        layer.name = 'interaction_thermal_imaging_transects';
        layer.title = 'Transekty - linia'
        layer.getLayer().setZIndex(2)

        handler.epMap.addCustomLayer(layer)

        super('thermal_imaging_transects', handler, layer);

        this.dictionary = {
            [InventoryLocationInteractionMode.DRAW]: 'Dodaj transekt',
            deleteConfirm: 'Czy na pewno chcesz usunąć wybrany transekt?',
            measurementTitle: 'Długość',
            measurementUnit: 'm'
        };

        // features layer
        const geometryFeaturesEpLayer = new EpLayer(handler.epMap.map);
        geometryFeaturesEpLayer.name = 'interaction_thermal_imaging_transect_features'
        geometryFeaturesEpLayer.title = 'Transekty - strefy'
        geometryFeaturesEpLayer.setStyle(inventoryLocationThermalImagingTransectsFeatureStyle);

        handler.epMap.addCustomLayer(geometryFeaturesEpLayer);
        this.geometryFeaturesEpLayer = geometryFeaturesEpLayer;

        // simplified features layer
        // const simplifiedFeaturesEpLayer = new EpInventoryLocationTransects(handler.epMap.map);
        // simplifiedFeaturesEpLayer.name = 'interaction_thermal_imaging_transect_simplified_features'
        // simplifiedFeaturesEpLayer.title = 'Transekty'
        // simplifiedFeaturesEpLayer.setStyle(null, inventoryLocationThermalImagingTransectsFeatureStyle);
        //
        // handler.epMap.addCustomLayer(simplifiedFeaturesEpLayer);
        // this.simplifiedFeaturesEpLayer = simplifiedFeaturesEpLayer;

        this.setupZoneClickHandler();
        this.setupTransectsButtonEventHandler();

        this.customCreateFeatureFromInput('LineString', null, 'Transekt');
        this.updateLengthInfo();
        this.updateAreaInfo();

        const modal = document.getElementById('drawTransectModal');
        modal.addEventListener('hide.bs.modal', () => {
            if(this.zoneDepth === null || this.areaType === null) {
                this.toggleInteraction()
            }
        })

        modal.addEventListener('show.bs.modal', () => {
            $('select[name="transect_area_type"]').val('').change();
        })

        $('#btnDrawTransect').click(async () => {
            this.zoneDepth = $('input[name="zone_depth"]:checked').val();
            this.areaType = $('select[name="transect_area_type"]').val();

            if(this.zoneDepth === "custom") {
                this.zoneDepth = parseInt($('#custom_zone_depth_input').val())/2
            }

            if(this.zoneDepth === '') {
                $('.error[data-for="custom_zone_depth_input"]').text('Musisz wprowadzić wartość');
                this.zoneDepth = null;
                this.areaType = null;
                return;
            }

            if(parseInt(this.zoneDepth) > ZONE_MAX_DEPTH) {
                $('.error[data-for="custom_zone_depth_input"]').text('Maksymalna wartość to ' + (ZONE_MAX_DEPTH*2));
                this.zoneDepth = null;
                this.areaType = null;
                return;
            }

            if(isNaN(parseInt(this.areaType))) {
                $('.error[data-for="transect_area_type"]').text('Musisz wybrać rodzaj');
                this.zoneDepth = null;
                this.areaType = null;
                return;
            }

            if(![1, 2].includes(parseInt(this.areaType))) {
                $('.error[data-for="transect_area_type"]').text('Wybrano niepoprawny rodzaj');
                this.zoneDepth = null;
                this.areaType = null;
                return;
            }

            closeModal('#drawTransectModal')
        })
    }

    customCreateFeatureFromInput(type = 'Polygon', style = null, name = null) {
        super.customCreateFeatureFromInput(type, style, name);

        if(typeof window._geometry_feature != 'undefined') {
            try {
                this.geometryFeatures = JSON.parse(window._geometry_feature) ?? [];
                this.geometryFeatures = Object.values(this.geometryFeatures);
                for(let geometryFeature of this.geometryFeatures) {
                    geometryFeature.coordinates = geometryFeature.coordinates.split(',').map(coord => parseFloat(coord))
                    geometryFeature.center = geometryFeature.center.split(',').map(coord => parseFloat(coord))
                }
            } catch(err) {
            }
        }

        let geometriesMeta = {};
        if(typeof window._geometries_meta != 'undefined') {
            geometriesMeta = JSON.parse(window._geometries_meta);
        }

        for(let feature of this.features) {
            const obj = geometriesMeta.find(g => parseInt(g.id) === parseInt(feature.get('id')));
            if(obj && obj.meta && obj.meta.depth) {
                feature.set('depth', parseInt(obj.meta.depth));
            } else {
                feature.set('depth', ZONE_DEFAULT_DEPTH)
            }

            const areaTypeInput = $(`input[name="thermal_imaging_area_types[${feature.get('id')}]"]`);
            if(areaTypeInput.length !== 0) {
                feature.set('area_type', parseInt(areaTypeInput.val()))

                $(`[data-app-map_interaction_area_type][data-app-feature_id="${feature.get('id')}"]`)
                    .text(parseInt(areaTypeInput.val()) === 2 ? 'polny' : 'leśny')
                    .data('app-area_type', parseInt(areaTypeInput.val()))
            }

            this.updateZones(feature.get('id'));
        }
    }

    addFeature(feature, id = null) {
        feature = super.addFeature(feature, id);

        // add area type input
        let areaTypeInput = $(`input[name="thermal_imaging_area_types[${feature.get('id')}]"]`);
        if(areaTypeInput.length === 0) {
            areaTypeInput = $(`
                    <input 
                        type="hidden" 
                        name="thermal_imaging_area_types[${feature.get('id')}]"
                        data-app-map_interaction_input="thermal_imaging_area_types"
                        value="${parseInt(feature.get('area_type'))}"
                        data-app-feature_id="${feature.get('id')}"
                   />
                `)

            $('#inputsContainer').append(areaTypeInput);
        }

        // add depth input
        // only if is not saved
        let depthInput = $(`input[name="thermal_imaging_transects_depth[${feature.get('id')}]"]`)
        if(depthInput.length === 0) {
            let geometriesMeta = {};
            if(typeof window._geometries_meta != 'undefined') {
                geometriesMeta = JSON.parse(window._geometries_meta);
            }

            const obj = geometriesMeta.find(g => parseInt(g.id) === parseInt(feature.get('id')));
            if(!obj) {
                feature.set('depth', parseInt(this.zoneDepth));

                depthInput = $(`
                    <input type="hidden" name="thermal_imaging_transects_depth[${feature.get('id')}]"
                       data-app-map_interaction_input="thermal_imaging_transects_depth"
                       value="${parseInt(this.zoneDepth)}"
                       data-app-feature_id="${feature.get('id')}"/>
                `)

                $('#inputsContainer').append(depthInput);
            }
        }

        return feature;
    }

    draw() {
        super.draw();
        let that = this;

        this.zoneDepth = null;
        this.areaType = null;
        $('.error[data-for="custom_zone_depth_input"]').text('');
        $('.error[data-for="transect_area_type"]').text('');
        openModal('#drawTransectModal')

        this.handler.epMap.helpTooltip.set('Aby zakończyć rysowanie linii, kliknij drugi raz w miejsce ostatniego punktu');
        this.addOlInteraction(
            this.epLayer.addDraw({
                noSource: true,
                style: drawInventoryLocationStyle,
                type: 'LineString',
                condition: (e) => {
                    let features = this.handler.epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                        layerFilter: (layer) => {
                            return layer === this.handler.epMap.boundaries.getLayer();
                        }
                    });
                    return features.length > 0;
                },
                end: function (e) {
                    e.feature.set('area_type', that.areaType)

                    let feature = that.addFeature(e.feature);
                    that.handler.setCurrentInteraction(null);

                    that.addToList(feature, 'Transekt #' + that.features.length);
                    that.updateLengthInfo();
                    that.updateAreaInfo();

                    e.feature.setStyle(inventoryLocationThermalImagingTransectsLineStyle)
                }
            })
        )
    }

    edit() {
        super.edit();

        let that = this;
        let feature = this.features.find(feature => feature.get('id') === this.currentId);
        let previousCoordinates = feature.getGeometry().getCoordinates();

        this.addOlInteraction(
            this.epLayer.addEdit({
                style: drawInventoryLocationStyle,
                features: new Collection([feature]),
                type: 'LineString',
                end: function (e) {
                    let feature = e.features.item(0);

                    if (
                        !turf.booleanWithin(
                            turf.lineString(feature.getGeometry().getCoordinates()),
                            that.handler.epMap.boundaries.getBufferedBoundariesPolygon(2)
                        )
                    ) {
                        feature.getGeometry().setCoordinates(previousCoordinates);
                        return;
                    }

                    that.updateFeature(feature);
                    previousCoordinates = feature.getGeometry().getCoordinates();

                    that.updateLengthInfo();
                }
            })
        )
    }

    toggleInteraction(id = null) {
        $('[data-app-map_interaction_transects_button]')
            .removeClass('btn-warning')
            .addClass('btn-primary');

        return super.toggleInteraction(id);
    }

    end(forced) {
        let currentId = null;
        if(this.currentId || this.features.length) {
            currentId = this.currentId ?? this.features[this.features.length - 1].get('id')
        }

        $('[data-app-map_interaction_transects_button]')
            .removeClass('btn-warning')
            .addClass('btn-primary');

        super.end(forced);

        this.updateLengthInfo();
        if(currentId) {
            this.updateZones(currentId);
        }
    }

    updateLengthInfo() {
        let summaryLength = 0;

        if (this.features.length) {
            for (let feature of this.features) {
                let length = getLength(feature.getGeometry());
                summaryLength += length;

                $(`[data-app-map_interaction_length="${this.name}"][data-app-feature_id="${feature.get('id')}"]`).text(length.toFixed(2))
            }
        }

        $('[data-app-information_name="transects_length"] [data-app-information_value]').text(summaryLength.toFixed(2))
    }

    updateAreaInfo() {
        const form = $('body').find('#addLocation, #editLocation');
        const areaInput = form.find('[name="area"]')
        const areaChangedManually = form.find('[name="area_changed_manually"]')

        let summaryArea = 0;
        let forestArea = 0;
        let fieldArea = 0;

        if (this.features.length) {
            for (let feature of this.features) {
                const metaArray = this.geometryFeatures.filter(g => g.feature_id === feature.get('id'))

                const left = EpInventoryLocationTransects.GenerateSimplifiedPolygons(
                    metaArray.map(meta => ({coordinates: meta.coordinates, meta})),
                    'LEFT'
                );

                const right = EpInventoryLocationTransects.GenerateSimplifiedPolygons(
                    metaArray.map(meta => ({coordinates: meta.coordinates, meta})),
                    'RIGHT'
                )

                if(left && right) {
                    const collection = turf.featureCollection([
                        left,
                        right
                    ]);
                    const area = turf.area(collection) / 10000
                    summaryArea += area;

                    if(parseInt(feature.get('area_type')) === 2) {
                        fieldArea += area;
                    } else {
                        forestArea += area;
                    }

                    $(`[data-app-map_interaction_area="${this.name}"][data-app-feature_id="${feature.get('id')}"]`).text((area).toFixed(2))
                } else {
                    confirmModal('Z narysowanym transektem wystąpiły błędy! Może to prowadzić do niższej wydajności działania mapy. Jeśli problem będzie dalej występował, skontaktuj się z obsługą.');
                }

                // this works, too
                // const area = collection.features.reduce((first, second) =>
                //     getArea(geoJSONtoOLFeature(first).getGeometry()) +
                //     getArea(geoJSONtoOLFeature(second).getGeometry())
                // );
            }
        }

        $('[data-app-information_name="transects_area"] [data-app-information_value]').text(summaryArea.toFixed(2))
        $('[data-app-information_name="transects_forest_area"] [data-app-information_value]').text(forestArea.toFixed(2))
        $('[data-app-information_name="transects_field_area"] [data-app-information_value]').text(fieldArea.toFixed(2))

        // update inputs
        const fieldAreaInput = $('[name="field_area"]');
        const forestAreaInput = $('[name="forest_area"]');

        if(fieldAreaInput.length) {
            $(`[data-app-information_name="areas_field_area"] [data-app-information_value]`)
                .each(function() { fieldArea += parseFloat($(this).text()) })

            fieldAreaInput.val(fieldArea.toFixed(2))
        }

        if(forestAreaInput.length) {
            $(`[data-app-information_name="areas_forest_area"] [data-app-information_value]`)
                .each(function() { forestArea += parseFloat($(this).text()) })

            forestAreaInput.val(forestArea.toFixed(2))
        }

        if (parseInt(areaChangedManually.val()) === 0 || areaInput.val().length === 0) {
            $(`[data-app-information_name="areas_area"] [data-app-information_value]`)
                .each(function() { summaryArea += parseFloat($(this).text()) })

            areaInput.val(summaryArea.toFixed(2));
        }
    }

    hide() {
        super.hide();
        this.handler.epMap.layerControl.handleVisibilityChange(this.geometryFeaturesEpLayer, false)
    }

    show() {
        super.show();
        this.handler.epMap.layerControl.handleVisibilityChange(this.geometryFeaturesEpLayer, true)
    }

    updateZones(id) {
        let feature = this.getCurrentFeature(id);

        /// Check in cache if coordinates have changed
        let coordinates = feature
            .getGeometry()
            .getCoordinates()
            .map(coords => coords.join(','))
            .join(' ');

        if(
            typeof this.geometryCoordinatesCache[id] != 'undefined' &&
            this.geometryCoordinatesCache[id] === coordinates
        ) {
            return;
        }

        this.geometryCoordinatesCache[id] = coordinates;

        /// Remove old geometry features from map
        let oldFeatures = this.geometryFeaturesEpLayer.getSource().getFeatures().filter(f => f.get('feature_id') === id);
        for (let f of oldFeatures) {
            this.geometryFeaturesEpLayer.getSource().removeFeature(f);
        }
        const previousGeometryFeatures = (this.geometryFeatures ?? []).filter(f => f.feature_id === id);

        // Clear from memory
        this.geometryFeatures = (this.geometryFeatures ?? []).filter(f => f.feature_id !== id);

        /// Generate points and lines
        const line = featureToGeoJSONObject(feature);
        const points = generatePointsOnLine(line, ZONE_LENGTH);
        const lines = generateLinesBasedOnPoints(points);

        /// Create point markers on map
        // for (let i = 0; i < points.features.length; i++) {
        //     let point = points.features[i];
        //
        //     const marker = geoJSONtoOLFeature(point);
        //     marker.setStyle(inventoryLocationThermalImagingTransectsLineStyle);
        //     this.epLayer.getSource().addFeature(marker);
        // }

        /// Generate polygons on both sides, process the depths
        let order = 1;
        for (let chunk of lines) {
            let leftDepth = feature.get('depth') ?? ZONE_DEFAULT_DEPTH;
            let rightDepth = feature.get('depth') ?? ZONE_DEFAULT_DEPTH;

            let geometryFeatureId = null;

            const center = turf.center(chunk);

            /// finding out old depths
            if(previousGeometryFeatures.length) {
                let lowestDistance = null;
                let closest = null;

                for(let previousGeometryFeature of previousGeometryFeatures) {
                    let distance = turf.distance(center, previousGeometryFeature.center, {units: 'meters'});
                    if(distance > ZONE_LENGTH*1.5) {
                        continue;
                    }

                    if(lowestDistance === null || lowestDistance > distance) {
                        lowestDistance = distance;
                        closest = previousGeometryFeature;
                    }
                }

                if(closest != null) {
                    geometryFeatureId = closest.id;
                    leftDepth = closest.left;
                    rightDepth = closest.right;
                }
            }

            if(geometryFeatureId === null) {
                geometryFeatureId = nanoid();
            }

            let leftFeature = createPolygonFeatureByLineAndWidth(chunk, 'LEFT', leftDepth, geometryFeatureId);
            let rightFeature = createPolygonFeatureByLineAndWidth(chunk, 'RIGHT', rightDepth, geometryFeatureId);

            leftFeature.set('feature_id', id);
            rightFeature.set('feature_id', id);

            this.geometryFeaturesEpLayer.getSource().addFeatures([leftFeature, rightFeature]);

            // Add to memory
            this.geometryFeatures = [
                ...this.geometryFeatures,
                {
                    id: geometryFeatureId,
                    feature_id: id,
                    coordinates: turf.getCoords(chunk).map(coord => coord.join(',')).join(' '),
                    center: turf.getCoords(center),
                    left: leftDepth,
                    right: rightDepth,
                    order
                }
            ]

            order++;
        }

        this.geometryFeaturesEpLayer.getSource().changed();
        this.updateAreaInfo();
    }

    setupZoneClickHandler() {
        let that = this;

        let feature = null;
        let coordinates = null;
        let originalPolygonCoordinates = null;
        let middleLine = null;
        let depth = null;
        let preventFromClicking = false;

        this.moveEvent = _.throttle(function (e) {
            coordinates = e.coordinate;

            if (!feature) {
                return;
            }

            const polygon = featureToGeoJSONObject(feature);
            const line = turf.lineString([
                turf.getCoords(polygon)[0][0],
                turf.getCoords(polygon)[0][1]
            ])

            const point = turf.point(proj4("EPSG:3857", "EPSG:4326", coordinates));

            const nearestPoint = turf.nearestPointOnLine(middleLine, point);
            const distance = roundToNearest(
                turf.pointToLineDistance(nearestPoint, line, {units: 'meters'}),
                [10, 20, 40, 60, 80, 100, 120, 160, 200, 240, 280, 300, 320, 360, 400, 440, 480, 520, 560, 600]
            );

            if (distance < 10 || distance > ZONE_MAX_DEPTH) {
                return;
            }

            depth = distance;
            that.handler.epMap.helpTooltip.set(`Szerokość: ${distance}m. Aby anulować, wciśnij klawisz ESC.`)

            let bearing = feature.get('bearing')

            const firstPoint = turf.destination(turf.getCoords(line)[1], distance, bearing, {units: 'meters'})
            const secondPoint = turf.destination(turf.getCoords(line)[0], distance, bearing, {units: 'meters'})

            const newPolygon = turf.polygon([
                [
                    ...turf.getCoords(line),
                    turf.getCoords(firstPoint),
                    turf.getCoords(secondPoint),
                    turf.getCoords(line)[0]
                ]
            ])

            const tempFeature = geoJSONtoOLFeature(newPolygon);
            feature.getGeometry().setCoordinates(tempFeature.getGeometry().getCoordinates());
        }, 50);

        this.clickEvent = function () {
            // Save changes
            feature.set('depth', depth);
            that.updateAreaInfo();

            // Update memory object
            let geometryFeatureObject = that.geometryFeatures.find(f => f.id === feature.get('id'))
            geometryFeatureObject[feature.get('side').toLowerCase()] = depth;

            that.handler.epMap.map.un('pointermove', that.moveEvent);
            that.handler.epMap.map.un('click', that.clickEvent);
            document.removeEventListener('keydown', that.keyDownEvent);

            that.handler.epMap.helpTooltip.clear();

            preventFromClicking = false;
        };

        this.keyDownEvent = function (e) {
            if (e.key === 'Escape') {
                that.handler.epMap.map.un('pointermove', that.moveEvent);
                that.handler.epMap.map.un('click', that.clickEvent);
                document.removeEventListener('keydown', that.keyDownEvent);

                feature.getGeometry().setCoordinates(originalPolygonCoordinates);
                that.handler.epMap.helpTooltip.clear();

                preventFromClicking = false;
            }
        }

        this.handler.epMap.map.on('click', function (e) {
            if (that.mode !== 'transects') {
                return;
            }

            let features = that.handler.epMap.map.getFeaturesAtPixel(e.pixel, {
                layerFilter: (layer) => layer === that.geometryFeaturesEpLayer.getLayer(),
            })
                .filter(f => f.get('feature_id') === that.currentId);

            if (features.length && !preventFromClicking) {
                preventFromClicking = true;

                // choose second side if same clicked
                if(
                    feature &&
                    features.length > 1 &&
                    features[0].get('id') === feature.get('id') &&
                    features[0].ol_uid === feature.ol_uid
                ) {
                    if(feature.get('id') === features[1].get('id')) {
                        feature = features[1];
                    } else {
                        feature = feature[0];
                    }
                } else {
                    feature = features[0];
                }

                originalPolygonCoordinates = feature.getGeometry().getCoordinates();
                depth = feature.get('depth');

                const polygon = featureToGeoJSONObject(feature);
                const line = turf.lineString([
                    turf.getCoords(polygon)[0][0],
                    turf.getCoords(polygon)[0][1]
                ])

                const endPoint = turf.destination(
                    turf.getCoords(turf.center(line)),
                    ZONE_MAX_DEPTH,
                    feature.get('bearing'),
                    {units: 'meters'}
                )

                middleLine = turf.lineString([
                    turf.getCoords(turf.center(line)),
                    turf.getCoords(endPoint)
                ])

                that.handler.epMap.map.on('pointermove', that.moveEvent)
                that.handler.epMap.map.on('click', that.clickEvent)
                document.addEventListener('keydown', that.keyDownEvent);
            }
        })
    }

    toggleTransectUpdateOn(button) {
        this.handler.setCurrentInteraction(this);
        this.mode = 'transects';

        this.handler.epMap.helpTooltip.set('Aby zmienić odległość, kliknij w wybrany prostokąt i przesuń kursor myszki')

        $(button).addClass('btn-warning');
    }

    toggleTransectUpdateOff() {
        this.end();
        this.mode = null;
        this.handler?.setCurrentInteraction(null);

        this.handler.epMap.helpTooltip.clear()

        this.handler.epMap.map.un('pointermove', this.moveEvent);
        this.handler.epMap.map.un('click', this.clickEvent);
        document.removeEventListener('keydown', this.keyDownEvent);
    }

    onDelete(id) {
        super.onDelete(id);

        /// Remove old zones
        let oldZones = this.geometryFeaturesEpLayer.getSource().getFeatures().filter(f => f.get('feature_id') === id);
        for (let f of oldZones) {
            this.geometryFeaturesEpLayer.getSource().removeFeature(f);
        }
    }

    setupTransectsButtonEventHandler() {
        let that = this;

        this.container.on('click', `[data-app-map_interaction_transects_button="${this.name}"]`, function () {
            that.currentId = $(this).attr('data-app-feature_id');

            let mode = that.mode;
            if (mode !== 'transects') {
                that.toggleTransectUpdateOn(this)
            } else {
                that.toggleTransectUpdateOff()
            }
        })
    }

    addToList(feature, name) {
        if (!this.list) {
            return;
        }

        this.list.append(`
            <div data-app-map_interaction_element="${this.name}" data-app-feature_id="${feature.get('id')}" class="col-12">
                <label>${name}</label>
                <div class="row g-1">
                    <div class="col-4">
                        <button 
                            type="button"
                            data-app-map_interaction_edit_button="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                            class="btn btn-primary w-100"
                        >
                            <i class="fas fa-pencil-alt"></i>
                        </button>
                    </div>
                    <div class="col-4">
                        <button 
                            type="button"
                            data-app-map_interaction_transects_button="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                            class="btn btn-primary w-100"
                        >
                            <i class="fas fa-wave-square"></i>
                        </button>
                    </div>
                    <div class="col-4">
                        <button 
                            type="button"
                            data-app-map_interaction_delete_button="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                            class="btn btn-danger w-100"
                        >
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
                <div class="row mt-2 g-1">
                    <div class="col-12">
                        Rodzaj obszaru: 
                        <a 
                            data-bs-toggle="tooltip"
                            title="kliknij, aby zmienić"
                            type="button"
                            class="btnEditAreaType link-underlined"
                            data-app-map_interaction_area_type="${this.name}"
                            data-app-feature_id="${feature.get('id')}"
                            data-app-area_type="${parseInt(feature.get('area_type') ?? 1)}"
                        >
                            ${parseInt(feature.get('area_type')) === 2 ? 'polny' : 'leśny'}
                        </a>
                    </div>
                    <div class="col-12">
                        Długość:
                        <span 
                            data-app-map_interaction_length="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                        >
                            
                        </span>m
                    </div>
                    <div class="col-12">
                        Powierzchnia:
                        <span 
                            data-app-map_interaction_area="${this.name}" 
                            data-app-feature_id="${feature.get('id')}"
                        >
                            0
                        </span>ha
                    </div>
                </div>
            </div>
        `);
    }

    regenerateSimplifiedFeatures(feature) {
        const metaArray = this.geometryFeatures.filter(f => f.feature_id === feature.get('id'))

        // const leftPolygons = EpInventoryLocationTransects.GenerateSimplifiedPolygons(
        //     metaArray.map(meta => ({coordinates: meta.coordinates, meta})),
        //     'LEFT'
        // )
        // const rightPolygons = EpInventoryLocationTransects.GenerateSimplifiedPolygons(
        //     metaArray.map(meta => ({coordinates: meta.coordinates, meta})),
        //     'LEFT'
        // )

        const toRemove = this.simplifiedFeaturesEpLayer
            .getSource()
            .getFeatures()
            .filter(feature => feature.get('feature_id', feature.get('id')))

        for (const f of toRemove) {
            this.simplifiedFeaturesEpLayer
                .getSource()
                .removeFeature(f)
        }

        this.simplifiedFeaturesEpLayer
            .createSimplifiedTransectsCollection(
                metaArray.map(meta => ({coordinates: meta.coordinates, meta}))
            )
    }
}